// The 17 UN Sustainable Development Goals, used for the "SDG Interventions" in Grants Module.
export const SDG_OPTIONS = [
  { value: "SDG 1: No Poverty", label: "SDG 1: No Poverty" },
  { value: "SDG 2: Zero Hunger", label: "SDG 2: Zero Hunger" },
  { value: "SDG 3: Good Health and Well-being", label: "SDG 3: Good Health and Well-being" },
  { value: "SDG 4: Quality Education", label: "SDG 4: Quality Education" },
  { value: "SDG 5: Gender Equality", label: "SDG 5: Gender Equality" },
  { value: "SDG 6: Clean Water and Sanitation", label: "SDG 6: Clean Water and Sanitation" },
  { value: "SDG 7: Affordable and Clean Energy", label: "SDG 7: Affordable and Clean Energy" },
  { value: "SDG 8: Decent Work and Economic Growth", label: "SDG 8: Decent Work and Economic Growth" },
  { value: "SDG 9: Industry, Innovation and Infrastructure", label: "SDG 9: Industry, Innovation and Infrastructure" },
  { value: "SDG 10: Reduced Inequalities", label: "SDG 10: Reduced Inequalities" },
  { value: "SDG 11: Sustainable Cities and Communities", label: "SDG 11: Sustainable Cities and Communities" },
  { value: "SDG 12: Responsible Consumption and Production", label: "SDG 12: Responsible Consumption and Production" },
  { value: "SDG 13: Climate Action", label: "SDG 13: Climate Action" },
  { value: "SDG 14: Life Below Water", label: "SDG 14: Life Below Water" },
  { value: "SDG 15: Life on Land", label: "SDG 15: Life on Land" },
  { value: "SDG 16: Peace, Justice and Strong Institutions", label: "SDG 16: Peace, Justice and Strong Institutions" },
  { value: "SDG 17: Partnerships for the Goals", label: "SDG 17: Partnerships for the Goals" },
];
